import { useSearchParams } from 'react-router-dom';
import { useCurrencies } from '../context/CurrencyContext';

// Currency is a read-only URL preference; amounts and account data are never stored here.
export const useCustomerCurrency = () => {
  const [params, setParams] = useSearchParams();
  const { codes, defaultCurrency, preferredCurrency, savePreferredCurrency } = useCurrencies();
  const candidate = params.get('currency');
  const currency = codes.includes(candidate) ? candidate : codes.includes(preferredCurrency) ? preferredCurrency : defaultCurrency;
  const setCurrency = code => {
    if (codes.includes(code)) {
      setParams(previous => { const next = new URLSearchParams(previous); next.set('currency', code); return next; }, { replace: true });
      savePreferredCurrency(code);
    }
  };
  return [currency, setCurrency];
};